export const invoiceAccountMixin = {
  computed: {
    // invoice_account_type_id
    newInvoiceAccount() {
      return [{
        account_type:             null,
        first_name:               null,
        last_name:                null,
        fiscal_code:              null,
        company_name:             null,
        vat_number:               null,
        country_id:               null,
        invoice_email:            null,
        pec:                      null,
        city_id:                  null,
        province:                 null,
        address:                  null,
        street_number:            null,
        city_name:                null,
        zip:                      null,
        invoice_account_type_id:  null,
        codice_destinatario_sdi:  null,
      }]
    },
    getInvoiceAccountTypeId() {
      return this.getInvoiceAccountTypeByType(this.account_type).id || this.invoice_account.invoice_account_type_id
    },
    submit_action() {
      return this.new_record ? 'create' : 'update'
    },
  },
}
